export default "__VITE_PUBLIC_ASSET__7517a35a__"